const onEnterSubmit = {
  keyboard_bindings_on_enter_submit() {
    return {
      onEnterSubmit: {
        key: "Enter",
        handler: () => {
          this.submit()
          return false
        },
      },
      onCtrlEnterAddLine: {
        key: "Enter",
        ctrlKey: true,
        handler: function () {
          const range = this.quill.getSelection()
          this.quill.insertText(range.index, "\n")
          return false
        },
      },
    }
  },
}

export default onEnterSubmit
